import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { terminalQrService } from "@/services/terminalQrService";
import { AuthShell } from "@/components/AuthShell";

/** Rota do QR: valida o token no servidor e encaminha para o Login existente. */
export default function TerminalLinkPage() {
  const { token } = useParams();
  const [state, setState] = useState("checking");

  useEffect(() => {
    terminalQrService.validate(token)
      .then(() => setState("valid"))
      .catch(() => setState("invalid"));
  }, [token]);

  if (state === "valid") return <Navigate to="/login" replace />;

  return (
    <AuthShell title="Terminal Web" subtitle="Acesso ao terminal de negociação">
      <div data-testid="terminal-link-page" className="flex flex-col items-center gap-3 py-6 text-center">
        {state === "checking" ? (
          <>
            <Loader2 className="h-5 w-5 animate-spin text-[#60A5FA]" />
            <p className="text-sm text-[#94A3B8]">A abrir o terminal…</p>
          </>
        ) : (
          <p data-testid="terminal-link-invalid" className="text-sm text-[#94A3B8]">
            Este código já não é válido. Peça um novo no painel da sua conta.
          </p>
        )}
      </div>
    </AuthShell>
  );
}
